import DetailActivity from "./DetailActivity";

export default DetailActivity;
